<template>
  <div class="addProjectApplication">
    <div class="newsDetial-header" v-if="id">
      <div v-if="tabnum == 1">
        <div class="newsDetial-title">建设项目申请</div>
        <blank height="7"> </blank>
        <div class="card-title">
          <div class="state1" v-if="Form.state == 1">审批中</div>
          <div class="state2" v-if="Form.state == 2">已归档</div>
          <div class="state3" v-if="Form.state == 3">退回</div>
          <div class="state4" v-if="Form.state == 4">取消</div>
        </div>
      </div>
      <div v-else>
        <div class="newsDetial-title">建设项目申请审批流程</div>
        <blank height="7"> </blank>
        <a-button
          v-if="Form.state == 2"
          class="detial-top-btn"
          type="primary"
          icon="printer"
          @click="printDDD()"
          >打印</a-button
        >
      </div>
      <a-tabs v-model="tabnum" @change="tabClick">
        <a-tab-pane key="1" tab="表单详情" />
        <!-- 草稿未开启审批流不展示跳转审批流按钮 -->
        <a-tab-pane key="2" tab="表单流程" v-if="Form.state > 0 && !version" />
      </a-tabs>
    </div>

    <div class="newsDetial-header" v-else>
      <div class="newsDetial-title">新建表单</div>
      <blank height="15"> </blank>
      <div class="newsDetial-abstract">
        请按照文本要求添加表单，并提交进行流程审批
      </div>
      <blank height="45"> </blank>
    </div>
    <div v-show="tabnum == 1">
      <div class="detial-cont">
        <div class="detial-cont-title">申请表单</div>
        <blank height="1"> </blank>
        <div class="detial-cont-view">
          <a-descriptions layout="vertical">
            <a-descriptions-item>
              <span slot="label"
                >项目申请部门<span class="required">*</span>
              </span>
              <a-tooltip placement="topLeft" :title="Form.organizationName">
                <div>
                  <a-input
                    v-if="id"
                    class="w300"
                    placeholder="请添加"
                    v-model="Form.organizationName"
                    disabled
                  />
                  <a-select
                    v-else
                    class="w300"
                    placeholder="请选择"
                    v-model="Form.organizationId"
                    :disabled="disabled"
                  >
                    <a-select-option
                      v-for="item in organizationUserList"
                      :value="item.organizationId"
                      :key="item.organizationId"
                    >
                      {{ item.organizationname }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-tooltip>
            </a-descriptions-item>
            <a-descriptions-item>
              <span slot="label"
                >项目申请时间<span class="required">*</span>
              </span>
              <a-date-picker
                class="w300"
                v-model="Form.projectApplyTime"
                :valueFormat="dateFormat"
                :disabled="disabled || formStep == 2"
              />
            </a-descriptions-item>

            <a-descriptions-item>
              <span slot="label"
                >申请项目名称<span class="required">*</span>
              </span>
              <a-input
                class="w300"
                placeholder="请添加"
                v-model="Form.projectName"
                :disabled="disabled || formStep == 2"
                @change="eightyfive('projectName', 85)"
              />
            </a-descriptions-item>
            <a-descriptions-item>
              <span slot="label"
                >项目预算（金额单位：元）<span class="required">*</span> </span
              ><a-input-number
                :min="0"
                :max="99999999999"
                class="w300"
                placeholder="请添加"
                v-model="Form.totalPrice"
                :disabled="disabled || formStep == 2"
              />
            </a-descriptions-item>
            <a-descriptions-item>
              <span slot="label">经办人<span class="required">*</span> </span>
              <a-select
                disabled
                placeholder="请添加"
                class="w300"
                v-model="Form.userId"
              >
                <a-select-option
                  v-for="i in queryUserList"
                  :value="i.id"
                  :key="i.id"
                  >{{ i.fullName }}</a-select-option
                >
              </a-select>
            </a-descriptions-item>

            <br />
            <a-descriptions-item label="申请事由">
              <a-input
                class="w500"
                v-model="Form.applyReason"
                type="textarea"
                :auto-size="{ minRows: 4, maxRows: 6 }"
                :disabled="disabled || formStep == 2"
                @change="eightyfive('applyReason', 200)"
              />
            </a-descriptions-item>
          </a-descriptions>
        </div>
      </div>
      <!-- 附件 -->
      <div class="detial-cont">
        <accessories-table
          v-model="updateList"
          :file="updateList"
          :disabled="disabled || formStep == 2"
        ></accessories-table>
      </div>
    </div>
    <!-- 第二步骤表单，进入审批流并且currentStep > 1才展示 formStep>1才可修改-->
    <div
      class="detial-cont detial-cont1"
      v-show="tabnum == 1 && Form.state > 0 && currentStep > 1"
    >
      <div class="detial-cont-title">
        公文文稿信息
        <a-button
          v-show="Form.state != 4 && Form.documentContent"
          :loading="WorkLoading"
          class="title-btn"
          type="primary"
          icon="play-circle"
          @click="createWork"
        >
          预览</a-button
        >
      </div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions bordered>
          <a-descriptions-item :span="3">
            <span slot="label" class="whiteSpace">标题</span>
            <a-input
              class="w800"
              placeholder="请添加标题"
              v-model="Form.documentTitle"
              :disabled="disabled || formStep == 1"
              @change="eightyfive('documentTitle', 85)"
            />
          </a-descriptions-item>
          <a-descriptions-item label="发文类别" :span="1.5">
            <a-select
              placeholder="请选择发文类别"
              class="w300"
              v-model="Form.documentCategory"
              @change="documentCategoryChange"
              :disabled="disabled || formStep == 1"
            >
              <a-select-option :value="1">行政</a-select-option>
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item label="发文分类" :span="1.5">
            <a-select
              class="w300"
              placeholder="请选择发文分类"
              v-model="Form.documentType"
              :disabled="disabled || formStep == 1"
            >
              <a-select-option
                v-for="item in documentTypeList"
                :value="item.valuename"
                :key="item.id"
              >
                {{ item.keyname }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item :span="1.5">
            <span slot="label" class="whiteSpace">发文编号文类别 </span>
            <a-select
              placeholder="请选择发文编号文类别"
              class="w300"
              :disabled="disabled || formStep == 1"
              v-model="Form.documentNumberCategory"
              @change="serialNumberTypeChange"
            >
              <a-select-option :value="1">编号文</a-select-option>
              <a-select-option :value="2">非编号文</a-select-option>
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item :span="1.5">
            <span slot="label" class="whiteSpace">发文编号 </span>
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.documentNumber"
              @change="eightyfive('documentNumber', 85)"
              :disabled="
                Form.documentNumberCategory == 2 || disabled || formStep == 1
              "
            />
          </a-descriptions-item>
          <a-descriptions-item label="发文单位" :span="1.5">
            <a-tree-select
              :disabled="disabled || formStep == 1"
              v-model="Form.documentNumberCompany"
              class="w300"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :tree-data="treeData"
              placeholder="发文单位"
              tree-default-expand-all
              :replaceFields="{
                key: 'id',
                value: 'id',
                children: 'treeList',
                title: 'organizationName'
              }"
            >
            </a-tree-select>
          </a-descriptions-item>
          <a-descriptions-item label="拟稿人" :span="1.5">
            <a-input
              class="w300"
              placeholder="请添加"
              :disabled="disabled || formStep == 1"
              v-model="Form.drafter"
            />
          </a-descriptions-item>

          <a-descriptions-item label="签发" :span="1.5">
            <a-select
              placeholder="请添加"
              class="w300"
              disabled
              v-model="Form.issue"
            >
              <a-select-option
                v-for="i in queryUserList"
                :value="i.id"
                :key="i.id"
                >{{ i.fullName }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item label="页头" :span="1.5">
            <a-select
              class="w300"
              placeholder="请选择页头"
              v-model="Form.pgHeader"
              :disabled="disabled || formStep == 1"
            >
              <a-select-option
                v-for="item in pgHeaderList"
                :value="item.header"
                :key="item.id"
              >
                {{ item.header }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item label="套红" disabled :span="1.5">
            <a-select
              disabled
              placeholder="请添加"
              class="w300"
              v-model="Form.overprint"
            >
              <a-select-option
                v-for="i in queryUserList"
                :value="i.id"
                :key="i.id"
                >{{ i.fullName }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>

          <a-descriptions-item label="发文日期" :span="1.5">
            <a-date-picker
              class="w300"
              v-model="Form.documentTime"
              :valueFormat="dateFormat"
              :disabled="disabled || formStep == 1"
            />
          </a-descriptions-item>
        </a-descriptions>
        <a-descriptions bordered>
          <a-descriptions-item>
            <span slot="label" class="whiteSpace"> 紧急程度 </span>
            <a-select
              placeholder="请选择"
              class="w200"
              v-model="Form.documentUrgentDegree"
              :disabled="disabled || formStep == 1"
            >
              <a-select-option :value="1">紧急</a-select-option>
              <a-select-option :value="2">一般</a-select-option>
            </a-select>
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label" class="whiteSpace"> 发文份数 </span>
            <a-input-number
              :min="0"
              :max="9999999999999999999"
              class="w200"
              placeholder="请添加"
              v-model="Form.documentCount"
              :disabled="disabled || formStep == 1"
            />
          </a-descriptions-item>
          <a-descriptions-item>
            <span slot="label" class="whiteSpace"> 资料等级 </span>
            <a-select
              placeholder="请选择"
              class="w200"
              v-model="Form.documentSecretLevel"
              :disabled="disabled || formStep == 1"
            >
              <a-select-option :value="10">普通</a-select-option>
              <a-select-option
                :value="100"
                :disabled="userInfo.secretLevel == 10"
                >重要</a-select-option
              >
            </a-select>
          </a-descriptions-item>
        </a-descriptions>
        <a-descriptions bordered>
          <a-descriptions-item :span="3">
            <span slot="label" class="whiteSpace"> 主送 </span>
            <a-select
              mode="multiple"
              placeholder="请添加"
              class="w800"
              :filter-option="filterOption"
              v-model="Form.groupIds"
              :disabled="disabled || formStep == 1"
            >
              <a-select-option
                v-for="i in GroupList"
                :value="i.id"
                :key="i.id"
                >{{ i.groupName }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>

          <a-descriptions-item :span="3">
            <span slot="label" class="whiteSpace"> 内容 </span>
            <div class="edui-default">
              <prompts>
                友情提示
                <div slot="two">
                  1.关于图片，设置最佳的图片尺寸为475px,等比例缩放，格式为居中，调整图片大小请使用鼠标拖动或点击图片进行修改设置；<br />
                  <blank height="5"> </blank>
                  2.关于字体大小，请选择富文本编辑器的字体大小，从其他粘贴过来的字体有可能会造成与系统字体不匹配的情况，请对粘贴过来的字体重新设置字体大小。
                  <blank height="8"> </blank>
                </div>
              </prompts>
              <blank height="15"> </blank>
              <template>
                <script id="editor" ref="ueditor" type="text/plain"></script>
                <blank height="15"> </blank>
              </template>
            </div>
          </a-descriptions-item>
          <a-descriptions-item label="附件" :span="3">
            <div class="fileDiv">
              <div class="fileDiv-left">
                <div v-for="(record, index) in upfileList" :key="index">
                  <a-button type="link">
                    {{ record.filename + '.' + record.fileformat }}
                  </a-button>
                  <a-button
                    type="link"
                    class="btn-link"
                    @click="goDetial(record)"
                  >
                    查看
                  </a-button>

                  <a-divider type="vertical" />
                  <a-button
                    type="link"
                    class="btn-link"
                    @click="
                      download(
                        record.mongoFileId,
                        record.filename,
                        record.fileformat
                      )
                    "
                  >
                    下载
                  </a-button>
                  <template v-if="!disabled && formStep > 1">
                    <a-divider type="vertical" />
                    <a-button
                      type="link"
                      class="btn-link"
                      @click="removeFiles(index)"
                    >
                      删除
                    </a-button>
                  </template>
                </div>
              </div>
              <div v-if="!disabled && formStep > 1">
                <a-upload
                  name="file"
                  :multiple="false"
                  :headers="headers"
                  action="#"
                  @change="uploadFiles"
                  :showUploadList="false"
                  :beforeUpload="beforeUpload"
                >
                  <a-button icon="plus"> 添加附件 </a-button>
                </a-upload>
                支持扩展名：.rar .zip .doc .docx .pdf .jpg...
              </div>
            </div>
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
    <div class="detial-cont" v-if="tabnum == 2">
      <div class="detial-cont-title">审批流程图示</div>
      <blank height="1"> </blank>
      <!-- 审批流 表单流程 -->
      <div class="detial-cont-view">
        <keep-alive>
          <approvalChart
            ref="refChart"
            :approvalChartData="approvalChartData"
          ></approvalChart>
        </keep-alive>
      </div>
    </div>
    <template v-if="tabnum == 1">
      <bottomSuspension>
        <a-button :style="{ marginRight: '20px' }" @click="goback">
          返回
        </a-button>
        <!-- 表单为可编辑状态 显示提交按钮 -->
        <template>
          <div v-if="proQueryParams.isEdit === '0' ? true : false">
            <a-button
              :loading="confirmLoading && Form.draft == 2"
              type="primary"
              class="orange-btn"
              @click="preserveFn('0')"
              :style="{ marginRight: '20px' }"
            >
              保存
            </a-button>
          </div>
          <a-button
            v-if="!Form.state && !disabled"
            :loading="confirmLoading && Form.draft == 1"
            type="primary"
            class="orange-btn"
            @click="preserveFn('1')"
            :style="{ marginRight: '20px' }"
          >
            保存
          </a-button>
          <a-button
            v-if="!Form.state && !disabled"
            :loading="loading && Form.draft == 2"
            type="primary"
            :style="{ marginRight: '20px' }"
            @click="submitFn"
          >
            提交
          </a-button>
          <a-button
            v-if="proQueryParams.showApproveBtn === '1'"
            :loading="loading && Form.draft == 2"
            type="primary"
            :style="{ marginRight: '20px' }"
            @click="submitFn"
          >
            {{ Form.state === 3 ? '提交' : '审批' }}
          </a-button>
        </template>
        <!-- 表单正在审批状态  显示审批按钮 -->
        <div v-if="proQueryParams.showApproveBtn === '1' ? true : false">
          <a-button
            v-if="Form.state === 3 ? true : false"
            type="danger"
            @click="cancelPro('2')"
            :style="{ marginRight: '20px' }"
          >
            删除
          </a-button>
          <!-- <a-button
            v-if="Form.state === 3 ? true : false"
            type="primary"
            @click="cancelPro('1')"
            :style="{ marginRight: '20px' }"
          >
            提交
          </a-button>
          <a-button
            v-if="Form.state === 3 ? false : true"
            @click="approvalPro"
            type="primary"
            :style="{ marginRight: '42px' }"
          >
            审批
          </a-button> -->
        </div>
      </bottomSuspension>
    </template>
    <!-- 审批流审批弹窗 -->
    <approvalSubmission v-model="isActivitiMode"></approvalSubmission>
    <print
      v-model="isPrint"
      v-if="Form.state == 2"
      :id="id"
      mobilePath="/pages/workbench/projectApply/details?id="
      skipPageReqFlag="/ProjectApplicationDetial"
    >
      <div class="Oprintd-title">北京民政工业总公司建设项目申请审批表</div>
      <div class="printd-cont offDetial">
        <div class="printd-item">
          <div class="printd-td">
            <a-descriptions bordered size="small">
              <a-descriptions-item label="项目申请部门" :span="3">
                {{ Form.organizationName }}
              </a-descriptions-item>
              <a-descriptions-item label="项目申请时间" :span="1.5">
                {{ Form.projectApplyTime }}
              </a-descriptions-item>
              <a-descriptions-item label="项目申请名称" :span="1.5">
                {{ Form.projectName }}
              </a-descriptions-item>
              <a-descriptions-item label="项目预算（元）" :span="1.5">
                {{ Form.totalPrice }}
              </a-descriptions-item>
              <a-descriptions-item label="经办人" :span="1.5">
                <span v-for="i in queryUserList" :key="i.id">
                  <span v-if="i.id == Form.userId">{{ i.fullName }}</span>
                </span>
              </a-descriptions-item>
              <a-descriptions-item label="公文标题" :span="3">
                {{ Form.documentTitle }}
              </a-descriptions-item>
              <a-descriptions-item label="发文类别" :span="1.5">
                <span v-if="Form.documentCategory == 1">行政</span>
                <span v-if="Form.documentCategory == 2">党工团</span>
              </a-descriptions-item>
              <a-descriptions-item label="发文分类" :span="1.5">
                {{ getByTypeName(Form.documentType, documentTypeList) }}
              </a-descriptions-item>
              <a-descriptions-item label="发文编号类别" :span="1.5">
                <span v-if="Form.documentNumberCategory == 1">编号文</span>
                <span v-if="Form.documentNumberCategory == 2">非编号文</span>
              </a-descriptions-item>
              <a-descriptions-item label="发文编号" :span="1.5">
                {{ Form.documentNumber }}
              </a-descriptions-item>
              <a-descriptions-item label="发文单位" :span="1.5">
                {{ Form.documentNumberCompany }}
              </a-descriptions-item>
              <a-descriptions-item label="拟稿人" :span="1.5">
                {{ Form.drafter }}
              </a-descriptions-item>
              <a-descriptions-item label="签发" :span="1.5">
                <span v-for="i in queryUserList" :key="i.id">
                  <span v-if="i.id == Form.issue">{{ i.fullName }}</span>
                </span>
              </a-descriptions-item>
              <a-descriptions-item label="页头" :span="1.5">
                {{ Form.pgHeader }}
              </a-descriptions-item>
              <a-descriptions-item label="套红" :span="1.5">
                <span v-for="i in queryUserList" :key="i.id">
                  <span v-if="i.id == Form.overprint">{{ i.fullName }}</span>
                </span>
              </a-descriptions-item>
              <a-descriptions-item label="拟稿日期" :span="1.5">
                {{ Form.documentTime }}
              </a-descriptions-item>

              <a-descriptions-item label="紧急程度" :span="1">
                <span v-if="Form.documentUrgentDegree == 1">紧急</span>
                <span v-if="Form.documentUrgentDegree == 2">一般</span>
              </a-descriptions-item>
              <a-descriptions-item label="发文份数" :span="1">
                {{ Form.documentCount }}
              </a-descriptions-item>
              <a-descriptions-item label="资料等级" :span="1">
                <span v-if="Form.documentSecretLevel == 10">普通</span>
                <span v-if="Form.documentSecretLevel == 100">重要</span>
              </a-descriptions-item>
              <a-descriptions-item label="主送" :span="3">
                <span v-for="(i, index0) in Form.groupIds" :key="index0">
                  <span v-for="v in GroupList" :key="v.id">
                    <span v-if="i == v.id" class="printd-item-span">{{
                      v.groupName
                    }}</span>
                  </span>
                </span>
              </a-descriptions-item>
            </a-descriptions>
          </div>
        </div>
        <div class="Oprintd-item-gw">
          <a-table
            size="small"
            :pagination="false"
            :columns="columns2"
            :data-source="formDTOList"
            :row-key="(record) => record.id"
            bordered
          >
          </a-table>
        </div>
      </div>
    </print>
  </div>
</template>

<script>
let vm = this
import {
  updateProjectApply,
  ProjectApplyDetial,
  addProjectApply,
  documentCategory,
  getSysHeader,
  projectApplyHistoryGet,
  createWord
} from './api/api'

import AccessoriesTable from '@/components/accessories-table/index.vue'
import { mapState, mapActions } from 'vuex'
import { saveFile, getFile } from '@/http/url'
import { getSuffix, formatDate, formatDateNoDetails } from '@/assets/js/auth'
import { kkFileUrl, fileUrlHOST } from '@/http/config'
import approvalSubmission from '@/components/approval-submission/index'
import approvalChart from '@/components/approval-chart/index'
import { activitiSubmission } from '@/utils/utils'
export default {
  data() {
    return {
      confirmLoading: false,
      loading: false,
      tabnum: '1', // 1表单页面， 2审批流页面
      Form: {},
      updateList: [], // 表单附件
      id: '',
      dateFormat: 'YYYY-MM-DD',
      headers: {
        Authentication: localStorage.getItem('token')
      },
      upfileList: [], //公文附件列表
      pgHeaderList: [], //页头
      WorkLoading: false,
      // 富文本
      editor: null,
      editorContent: '',
      isDisabledTrue: true,
      // 审批流部分
      // disabled: true,
      isActivitiMode: {
        isActivitiShow: false,
        proQueryParams: []
      },
      proQueryParams: [],
      currentStep: 100, //表单显示步骤   100 全显示，1显示第一步，2显示第二部
      formStep: 100, //表单可修改步骤   100 全表单 1 代表第一步骤 2 代表第二步骤
      version: '',
      formDTOList: [],
      isPrint: false, // 打印弹窗
      columns2: [
        {
          title: '审批部门（人）',
          dataIndex: 'dutyOfficerStr',
          key: 'dutyOfficerStr',
          align: 'left'
        },
        {
          title: '审批意见',
          dataIndex: 'fieldValue1',
          key: 'fieldValue1',
          align: 'cneter'
        },
        {
          title: '审批时间',
          dataIndex: 'createTime',
          key: 'createTime',
          align: 'center'
        }
      ],
      pIsedit: ''
    }
  },
  components: {
    AccessoriesTable,
    approvalSubmission,
    approvalChart
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.app.userInfo, //用户信息
      treeData: (state) => state.app.organizeList, // 组织机构树
      organizationUserList: (state) => state.app.organizationUserList, // 当前用户可选部门
      queryUserList: (state) => state.app.queryUserList, // 用户列表
      GroupList: (state) => state.app.GroupList, // 分组列表
      documentTypeList: (state) => state.bytype.documentTypeList // 发文分类
    }),
    // 获取表单是否可编辑状态  false可编辑  true不可编辑
    disabled: function () {
      if (!this.id) {
        // id不存在  为添加  可编辑
        return false
      } else {
        this.proQueryParams = this.$route.query
        if (this.proQueryParams.isEdit) {
          if (
            this.proQueryParams.isEdit === '100' ||
            this.proQueryParams.isEdit === '1'
          ) {
            return true
          } else {
            return false
          }
        } else if (this.Form.state == 1 || this.Form.state == 2) {
          //审批状态和归档状态  不可编辑
          return true
        } else {
          // 草稿箱或退回状态  可编辑
          return false
        }
      }
    }
  },
  created() {
    vm = this
  },
  mounted() {
    this.getByType()
    this.id = this.$route.query.id ? this.$route.query.id : ''
    this.version = this.$route.query.version ? this.$route.query.version : ''
    this.currentStep = this.$route.query.currentStep
      ? parseInt(this.$route.query.currentStep)
      : 100
    this.formStep = this.$route.query.formStep
      ? parseInt(this.$route.query.formStep)
      : 100
    if (this.id) {
      if (this.version) {
        this.HistoryGetFn()
      } else {
        this.ProjectApplyDetialFn()
      }
      // 判断富文本是否可编辑
      if (!this.disabled && this.formStep != 1) {
        // 可编辑
        this.isDisabledTrue = true
        this.wangeditorFn()
      } else {
        this.isDisabledTrue = false
        this.wangeditorFn()
      }
    } else {
      //添加
      this.Form.userId = this.$store.state.app.userInfo.id
      let date = new Date()
      this.$set(this.Form, 'projectApplyTime', formatDateNoDetails(date))
      this.$set(
        this.Form,
        'organizationId',
        this.$store.state.app.organizationId
      )
    }
  },
  methods: {
    createWork() {
      //生成work文档
      this.WorkLoading = true
      createWord(this.id).then((res) => {
        if (res.data.code == 0) {
          // 查看
          this.WorkLoading = false
          let item = res.data.data
          if (item.fileformat == 'bpmn') {
            this.$message.error('该文件类型(bpmn)系统暂时不支持在线预览')
          } else {
            let Base64 = require('js-base64').Base64
            window.open(
              item.kkFileUrl + encodeURIComponent(Base64.encode(item.fileUrl))
            )
          }
        } else {
          this.WorkLoading = false
        }
      })
    },
    // 输入框限制85
    eightyfive(v, maxNum) {
      if (this.Form[v].length > maxNum) {
        this.Form[v] = this.Form[v].substring(0, maxNum)
        this.$message.destroy()
        this.$message.warning('只能输入' + maxNum + '个字')
      }
    },
    //通过字典值过去字典名
    getByTypeName(value, list) {
      let byType = list.find((item) => {
        return item.valuename == value
      })
      if (byType) {
        return byType.keyname
      } else {
        return value
      }
    },
    printDDD() {
      this.formDTOList = this.$refs.refChart.getHighLine.formDTOList
      this.isPrint = true
      document.title =
        '建设项目申请-' +
        this.Form.projectName +
        this.$printFormatDate(new Date())
    },
    // 详情
    HistoryGetFn() {
      projectApplyHistoryGet({ id: this.id, version: this.version }).then(
        (res) => {
          if (res.data.code == 0) {
            this.Form = res.data.data
            this.updateList = this.Form.dfile
            if (this.Form.documentfile) {
              this.upfileList = this.Form.documentfile
            }
            // 多个对象合并合并多个
            let processInstanceId = {
              processInstanceId: res.data.data.processInstanceId,
              detailsData: res.data.data
            }
            Object.assign(this.proQueryParams, processInstanceId)
            if (res.data.data.documentContent) {
              setTimeout(() => {
                this.editor.setContent(res.data.data.documentContent)
              }, 600)
            }
          }
        }
      )
    },
    ProjectApplyDetialFn() {
      ProjectApplyDetial({ id: this.id }).then((res) => {
        if (res.data.code == 0) {
          this.Form = res.data.data
          this.updateList = this.Form.dfile
          if (this.Form.documentfile) {
            this.upfileList = this.Form.documentfile
          }
          // 多个对象合并合并多个
          let processInstanceId = {
            processInstanceId: res.data.data.processInstanceId,
            detailsData: res.data.data
          }
          Object.assign(this.proQueryParams, processInstanceId)
          if (res.data.data.documentContent) {
            setTimeout(() => {
              this.editor.setContent(res.data.data.documentContent)
            }, 600)
          }
        }
      })
    },
    wangeditorFn() {
      // 初始化百度ueditor富文本
      UE.delEditor('editor')
      UE.getEditor('editor', {
        initialFrameWidth: '100%',
        initialFrameHeight: 450, // 设置默认高度
        scaleEnabled: true // 不自动拉伸高度
      })
      this.editor = UE.getEditor('editor', {
        // initialContent: '请输入内容', // 初始化编辑器的内容,也可以通过textarea/script给值
        BaseUrl: '',
        UEDITOR_HOME_URL: vm.$bdPackConfig.baiduEditorUrl,
        autoFloatEnabled: false
      })
      UE.Editor.prototype._bkGetActionUrl = UE.Editor.prototype.getActionUrl
      UE.Editor.prototype.getActionUrl = function (action) {
        // let ts = this
        if (action === 'upload') {
          return vm.$bdPackConfig.baiduUploadUrl
        } else {
          return this._bkGetActionUrl.call(this, action)
        }
      }
      let ue = UE.getEditor('editor')
      if (!this.isDisabledTrue) {
        // 处理all-editor报错 无法禁用富文本问题
        document.getElementById('edui1_toolbarbox').style.display = 'none'
        ue.ready(function () {
          ue.setDisabled()
        })
      } else {
        ue.ready(function () {
          ue.setEnabled()
        })
      }
    },
    serialNumberTypeChange(val) {
      if (val == 2) {
        delete this.Form.documentNumber
      }
      // 页头
      delete this.Form.pgHeader
      this.getpgHeader(val)
      this.$forceUpdate
    },

    // 审批流取消
    cancelPro(key) {
      switch (key) {
        case '1':
          // 提交
          this.$confirm({
            title: '您是否提交?',
            onOk: () => {
              activitiSubmission(this.proQueryParams, '1', this)
            },
            onCancel: () => {
              console.log('Cancel')
            }
          })
          break
        case '2':
          // 取消
          this.$confirm({
            title: '您是否删除?',
            onOk: () => {
              activitiSubmission(this.proQueryParams, '2', this)
            },
            onCancel: () => {
              console.log('Cancel')
            }
          })
          break

        default:
          break
      }
    },
    // 切换审批流 表单流程
    tabClick(key) {
      if (key == 2) {
        this.approvalChartData = this.proQueryParams
      } else {
        this.ProjectApplyDetialFn()
      }
    },
    // 固定资产 申请模块 工作流审批
    approvalPro() {
      this.isActivitiMode = {
        isActivitiShow: true,
        proQueryParams: this.proQueryParams
      }
    },
    ...mapActions([
      'getorganizationUserList',
      'getorganizeListFn',
      'getdocumentType',
      'getqueryUserList',
      'getGroupList'
    ]),
    // 获取当前页面所需字典表
    getByType() {
      //获取组织机构
      this.getorganizeListFn()
      //  当前用户可选部门
      this.getorganizationUserList()
      //发文分类
      this.getdocumentType()
      // 用户列表
      this.getqueryUserList()
      // 分组
      this.getGroupList()
    },
    // 多选搜索按名字搜
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    getpgHeader(numberType) {
      getSysHeader({ administration: 1, modelType: 1, numberType }).then(
        (res) => {
          if (res.data.code == 0) {
            this.pgHeaderList = res.data.data
          }
        }
      )
    },
    documentCategoryChange() {
      documentCategory({ documentCategory: this.Form.documentCategory }).then(
        (res) => {
          if (res.data.code == 0) {
            this.Form.issue = res.data.data.issueUserIds
            this.Form.overprint = res.data.data.overprintUserIds
            this.$forceUpdate()
          }
        }
      )
    },
    formatDateIt(data) {
      // 时间格式化
      return formatDate(data)
    },
    // 上传附件
    uploadFiles(file) {
      if (file.file.size > 10485760) {
        // 大于10M 拦截
        this.$message.error('上传文件不得大于10M！')
      } else {
        this.saveFileFn(file.file)
      }
    },
    beforeUpload() {
      return false
    },
    saveFileFn(file) {
      const formDataChildren = new FormData()
      formDataChildren.append('file', file)
      this.$message.loading('上传中···', 0)
      saveFile(formDataChildren).then((res) => {
        if (res.data.code == 0) {
          this.$message.destroy()
          this.$message.success('上传成功')
          let fileData = {}
          let SuffixArray = getSuffix(file.name)
          fileData.filename = SuffixArray[1]
          fileData.fileformat = SuffixArray[0]
          fileData.mongoFileId = res.data.data
          fileData.kkFileUrl = kkFileUrl
          fileData.fileUrl =
            fileUrlHOST +
            'mongo/kkFile?fileId=' +
            fileData.mongoFileId +
            '&fullfilename=' +
            SuffixArray[2]

          fileData.createTime = this.formatDateIt(new Date())
          this.upfileList.push(fileData)
        }
      })
    },
    // 移除
    removeFiles(index) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          this.upfileList.splice(index, 1)
          this.$message.success('删除成功')
        }
      })
    },
    goDetial(item) {
      // 查看
      if (item.fileformat == 'bpmn') {
        this.$message.error('该文件类型(bpmn)系统暂时不支持在线预览')
      } else {
        // window.open(item.kkFileUrl + encodeURIComponent(item.fileUrl))
        let Base64 = require('js-base64').Base64
        window.open(
          item.kkFileUrl + encodeURIComponent(Base64.encode(item.fileUrl))
        )
      }
    },
    download(mongoFileId, filename, fileformat) {
      // 下载附件
      getFile(mongoFileId).then((res) => {
        let blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel'
        })
        let fileName = filename + '.' + fileformat
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      })
    },
    goback() {
      this.$router.push('/ProjectApplication')
    },
    preserveFn(type) {
      if (type === '0') {
        // 自定义保存判断 1 = 仅保存
        this.pIsedit = '1'
        this.Form.draft = 2
      } else {
        this.pIsedit = '2'
        this.Form.draft = 1
      }
      if (!this.Form.organizationId) {
        this.$message.error('请添加项目申请部门')
        return false
      }
      if (!this.Form.projectApplyTime) {
        this.$message.error('请选择项目申请时间')
        return
      }
      if (!this.Form.projectName) {
        this.$message.error('请添加项目名称')
        return
      }
      if (!this.Form.totalPrice) {
        this.$message.error('请添加项目预算')
        return
      }
      this.confirmLoading = true
      this.formStep = 1
      this.saveFormFn('保存')
    },

    submitFn() {
      if (this.editor) {
        this.Form.documentContent = this.editor.getContent()
      }
      if (!this.Form.organizationId) {
        this.$message.error('请添加项目申请部门')
        return false
      }
      if (!this.Form.projectApplyTime) {
        this.$message.error('请选择项目申请时间')
        return
      }
      if (!this.Form.projectName) {
        this.$message.error('请添加项目名称')
        return
      }
      if (!this.Form.totalPrice) {
        this.$message.error('请添加项目预算')
        return
      }

      if (this.Form.state > 0) {
        this.Form.draft = 2
        this.saveFormFn('添加')
      } else {
        this.$confirm({
          title: '确定提交吗?',
          okType: 'danger',
          onOk: () => {
            this.Form.draft = 2
            this.saveFormFn('添加')
          }
        })
      }
    },
    saveFormFn(type) {
      this.Form.dfile = this.updateList
      this.Form.appId = this.$route.meta.appId
      this.Form.skipPageReqFlag = '/ProjectApplicationDetial'
      if (this.pIsedit === '') {
        this.loading = true
      } else {
        this.confirmLoading = true
      }
      if (this.id) {
        // 表单步骤：formStep: 100 全表单 1 代表第一步骤 2 代表第二步骤
        // this.Form.formStep = this.formStep

        if (this.Form.state > 0) {
          // 工作流开始之后
          this.Form.formStep = this.formStep
        } else {
          //工作流未开始只能改表单第一步
          this.Form.formStep = 1
        }
        this.Form.documentfile = this.upfileList // 公文文件赋值
        updateProjectApply(this.Form).then((res) => {
          if (res.data.code == 0) {
            if (this.pIsedit === '1') {
              this.$message.success('保存成功')
              this.pIsedit = ''
            } else {
              if (this.Form.state > 0) {
                this.ProjectApplyDetialFn()
                // 合并 保存+审批流操作
                if (
                  this.proQueryParams.showApproveBtn === '1' &&
                  this.Form.state != '3'
                ) {
                  this.approvalPro()
                } else {
                  this.cancelPro('1')
                }
                // this.$message.success('修改成功')
                // 合并 保存+审批流操作
              } else {
                if (this.Form.draft == 2) {
                  this.$message.success('提交成功')
                  this.goback()
                } else {
                  this.$message.success('保存成功')
                }
              }
            }
            this.loading = false
            this.confirmLoading = false
          } else {
            this.loading = false
            this.confirmLoading = false
          }
        })
      } else {
        this.Form.formStep = 1
        //获取部门名称
        let organizationName = ''
        this.organizationUserList.forEach((item, index) => {
          if (item.organizationId == this.Form.organizationId) {
            organizationName = item.organizationname
          }
        })
        this.Form.organizationName = organizationName
        addProjectApply(this.Form).then((res) => {
          if (res.data.code == 0) {
            this.$message.success(type + '成功')
            if (this.Form.draft == 2) {
              this.goback()
            } else {
              //首次添加
              this.id = res.data.data
              this.ProjectApplyDetialFn()
            }
            this.loading = false
            this.confirmLoading = false
          } else {
            this.loading = false
            this.confirmLoading = false
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.edui-default {
  width: 857px;
  margin: 0 auto;
}
.addProjectApplication {
  .newsDetial-header {
    position: relative;
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
    .detial-top-btn {
      position: absolute;
      right: 87px;
      top: 0;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
      position: relative;
      .title-btn {
        position: absolute;
        top: 10px;
        right: 30px;
      }
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .accessory-btn {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .fileDiv {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
}
.whiteSpace {
  white-space: nowrap;
}
// 打印内容不能嵌套写样式

.Oprintd-title {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
  color: rgba(255, 87, 51, 1);
}
.printd-item-span {
  margin-right: 10px;
}
</style>
<style lang="scss">
.addProjectApplication {
  .detial-cont1 {
    .detial-cont-view {
      .ant-descriptions-bordered .ant-descriptions-view {
        border: none;
      }
      .ant-descriptions-view {
        border-radius: 0;
      }
      .ant-descriptions-item-label {
        background: #fff;
      }
      .ant-descriptions-bordered .ant-descriptions-view {
        border-top: rgba(255, 87, 51, 1) solid 1px;
        border-left: rgba(255, 87, 51, 1) solid 1px;
      }
      .ant-descriptions-row {
        border-bottom: rgba(255, 87, 51, 1) solid 1px;
      }
      .ant-descriptions-bordered .ant-descriptions-item-label,
      .ant-descriptions-bordered .ant-descriptions-item-content {
        border-right: rgba(255, 87, 51, 1) solid 1px;
        //   text-align: right;
      }
    }
  }
}

.printd-td {
  .ant-descriptions-view {
    border-radius: 0;
  }
  .ant-descriptions-item-label {
    background: #fff;
  }
  .ant-descriptions-bordered .ant-descriptions-view {
    border-top: rgba(255, 87, 51, 1) solid 1px;
    border-left: rgba(255, 87, 51, 1) solid 1px;
    color: rgba(255, 87, 51, 1);
  }
  .ant-descriptions-row {
    border-bottom: rgba(255, 87, 51, 1) solid 1px !important;
    color: rgba(255, 87, 51, 1);
  }
  .ant-descriptions-bordered .ant-descriptions-item-label,
  .ant-descriptions-bordered .ant-descriptions-item-content {
    border-right: rgba(255, 87, 51, 1) solid 1px !important;
    color: rgba(255, 87, 51, 1);
    overflow: hidden;
  }
}
.Oprintd-item-gw {
  .ant-table-bordered .ant-table-thead > tr > th,
  .ant-table-bordered .ant-table-tbody > tr > td {
    // border: 1px solid rgba(255, 87, 51, 1);
    color: rgba(255, 87, 51, 1);
  }
}
</style>

<!-- 打印弹窗ant-table的样式  -->
<style scoped src="@/views/OfficialDocument/css/offcialPrintMoadl.css"></style>



// WEBPACK FOOTER //
// src/views/ProjectApplication/detial.vue